<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')">
		<el-form label-position="left" label-width="100px">
			<el-form-item label="感受到的問題" v-if="editStoryData.problem">
				<el-input type="textarea" placeholder="請簡短敘述您感受到的問題" :autosize="{ minRows: 3}" v-model="editStoryData.problem" :readonly="true" resize="none"></el-input>
			</el-form-item>
			<el-form-item label="感受到的問題" v-else>
				<span class="color-danger">尚未填寫</span>
			</el-form-item>
		</el-form>
	</brows-layout>
</template>

<script>
import BrowsLayout from "./BrowsLayout.vue";

export default {
	components: { BrowsLayout },
	props: ["editStoryData"],
	data() {
		return {};
	}
};
</script>